import { Directive, Input, HostListener, OnChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMasks]'
})
export class MasksDirective implements OnChanges {

  @Input() appMasks: string;

  constructor(private ctrl: NgControl) {}

  private format(v: string): string {
    let s = '';
    const matches = v.match(/[a-zA-Z0-9]+/g);

    if (matches !== null) {
      let value = matches.join('').split('');
      const chars = this.appMasks.split('');

      for (const c of chars) {
        if (value.length === 0) {
          break;
        }

        switch (c) {
          case '#':
            s += value[0];
            value = value.slice(1);
            break;

          case '9':
            if (value[0].match(/\d/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
            break;

          case 'A':
            if (value[0].match(/[a-zA-Z]/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
            break;
          case 'H':
            if (value[0].match(/[0]?[0-2]/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
             break;
          case 'h':
            if (value[0].match(/[*2]?[0-4]|[1-9]/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
            break;
          case 'M':
            if (value[0].match(/[0-5]/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
            break;
          case 'm':
            if (value[0].match(/[0-9]/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
            break;
          default:
            s += c;
        }
      }
    }
    return s;
  }

  /**
   * @description when loading dynamically data to the input, without this
    * the mask will only work on keyup event changes
   */
  @HostListener('change') ngOnChanges() {
    const value = this.ctrl.control.value;
     if (value) {
      this.ctrl.control.setValue(this.format(value));
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp($event: any) {
    if ($event.keyCode !== 13 && $event.keyCode !== 9) {
      const value = this.ctrl.control.value;
      this.ctrl.control.setValue(this.format(value));
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/masks/masks.directive.ts